"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadgeGrantedEvent = void 0;
const validation_1 = require("../../validation");
const base_1 = require("./base");
var BadgeGrantedEvent;
(function (BadgeGrantedEvent) {
    BadgeGrantedEvent.schema = {
        type: 'object',
        properties: {
            type: { type: 'string', const: base_1.Events.Type.BADGE },
            subType: { type: 'string', const: base_1.Events.SubType.Badge.GRANTED },
            key: { type: 'string' },
            timestamp: { type: 'number', minimum: 0 },
            metadata: {
                type: 'object',
                properties: {
                    badgeId: { type: 'string' },
                    badgeTierName: { type: 'string', nullable: true },
                    badgeName: { type: 'string' },
                    badgeImageUrl: { type: 'string' },
                    address: { type: 'string' }
                },
                required: ['badgeId', 'badgeName', 'badgeImageUrl', 'address']
            }
        },
        required: ['type', 'subType', 'key', 'timestamp', 'metadata'],
        additionalProperties: true
    };
    BadgeGrantedEvent.validate = (0, validation_1.generateLazyValidator)(BadgeGrantedEvent.schema);
})(BadgeGrantedEvent = exports.BadgeGrantedEvent || (exports.BadgeGrantedEvent = {}));
//# sourceMappingURL=services.js.map